<template>
    <div class="about">
        <div class="backHome" @click="backHome">
            <img src="../../assets/user/close.png" alt="" />
        </div>
        <h1 class="h1">{{ title }}</h1>
        <h2 class="h2">{{ about.h2 }}</h2>
        <div class="basicWapper">
            <div class="img"><img v-if="logo" :src="logo" alt="" /></div>
            <div class="msg">
                <p>
                    <span>{{ about.msg1 }}:</span><span>{{ register_capital }}</span>
                </p>
                <p>
                    <span>{{ about.msg2 }}:</span><span>{{ employee_num | employee_nums }}</span>
                </p>
                <p>
                    <span>{{ about.msg3 }}:</span><span>{{ website }}</span>
                </p>
                <p class="itemWrap">
                    <span>{{ about.msg4 }}:</span><span class="itemContent">{{ main_products }}</span>
                </p>
                <p class="itemWrap">
                    <span>{{ about.msg5 }}:</span><span class="itemContent">{{ sale_scope }}</span>
                </p>
            </div>
        </div>
        <div class="textWapper">
            <h2 class="h2">{{ about.h2 }}</h2>
            <p class="text">
                {{ text }}
            </p>
        </div>
    </div>
</template>

<script>
import api from "@/api";
// import { exhibition_id } from "@/utils/exhibitId";
export default {
    name: "About",
    data() {
        return {
            title: "", //企业名称
            logo: "", //logo
            text: "", //基本信息
            register_capital: "", //注册资本
            employee_num: "", //企业规模
            website: "", //网址
            main_products: "", //主营产品
            sale_scope: "", //销售范围
            company_id: null,
            exhibition_id: ''
        };
    },
    mounted() {
        this.company_id = Number(this.$route.query.company_id);
        this.exhibition_id = this.$route.query.exhibition_id 
        this.title = "";
        this.logo = "";
        this.text = "";
        this.register_capital = "";
        this.employee_num = "";
        this.website = "";
        this.main_products = "";
        this.sale_scope = "";
        this.getExhibitor();
    },
    methods: {
        backHome() {
            this.$root.$emit("close");
            this.$emit("cancel", 1);
        },
        getExhibitor() {
            api.getExhibitionDetali({
                id: this.company_id,
                params: {
                    exhibition_id: this.exhibition_id
                }
            }).then((res) => {
                // console.log(res.info)
                this.title = res.info.company.name;
                this.logo = res.info.profile.cn.images.length ? res.info.profile.cn.images[0].url : "";
                this.text = res.info.profile.cn.info;
                this.main_products = res.info.profile.cn.main_products;
                this.sale_scope = res.info.profile.cn.sale_scope;
                this.register_capital = res.info.company.register_capital;
                this.employee_num = res.info.company.employee_num;
                this.website = res.info.company.website;
                console.log(res.info);
            });
        }
    },
    computed: {
        about() {
            return this.$t("about");
        }
    },
    filters: {
        employee_nums(val) {
            let str = "";
            switch (val) {
                case 1:
                    str = "0~49人";
                    break;
                case 2:
                    str = "50~199人";
                    break;
                case 3:
                    str = "200~999人";
                    break;
                case 4:
                    str = "1000~9999人";
                    break;
                case 5:
                    str = "10000人以上";
                    break;
                default:
                    str = "未知";
            }
            return str;
        }
    }
};
</script>

<style lang="scss" scoped>
.about {
    width: 656px;
    height: 433px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
    border-radius: 30px;
    box-sizing: border-box;
    padding: 15px 20px 27px;
    .h1 {
        width: 100%;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5f7185;
        line-height: 28px;
        text-align: center;
        margin-bottom: 20px;
        color: #09468c;
    }
    .h2 {
        width: 100%;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #09468c;
        line-height: 22px;
        margin-bottom: 13px;
    }
    .basicWapper {
        width: 100%;
        height: 133px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 20px;
        .img {
            width: 187px;
            height: 100%;
            flex-shrink: 0;
            background-color: #aaa;
            > img {
                width: 100%;
                height: 100%;
            }
        }
        .msg {
            margin-left: 13px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 24px;
            color: #09468c;
            span:last-of-type {
                margin-left: 12px;
            }
            .itemWrap {
              display: flex;
            }
            .itemContent {
                flex: 1;
                max-height: 30px;
                overflow: auto;
            }
        }
    }
    .textWapper {
        
        height: 180px;
        .text {
            height: 150px;
            overflow-y: auto;
            /*定义滚动条高宽及背景*/
            &::-webkit-scrollbar {
                width: 1px;
            }
            /*定义滚动条*/
            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                -webkit-box-shadow: inset 0 0 5px #fff;
                background: #fff;
            }
            /*定义滚动条轨道*/
            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 5px #fff;
                border-radius: 0;
                background: rgba(0, 0, 0, 0.1);
            }
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #09468c;
            line-height: 21px;
            text-align: justify;
        }
    }
}
.backHome {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 21px;
    right: 21px;
    cursor: pointer;
    border-radius: 50%;
    > img {
        width: 100%;
        height: 100%;
    }
}
.backHome:hover {
    background-color: #e8eef4;
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue